import React, { useContext, createContext, useEffect, useState } from "react";
import { fetchProofPoints } from "../services/proofPointsService";

export type ProofPointItem = {
  iconURL: string;
  heading: string;
  text: string;
};

export type ProofPointsContext = {
  proofPoints?: ProofPointItem[];
};

export const ProofPointsContext = createContext<ProofPointsContext>({});

export const ProofPointsProvider: React.FunctionComponent = ({ children }) => {
  const [proofPoints, setProofPoints] = useState<
    ProofPointItem[] | undefined
  >();

  useEffect(() => {
    fetchProofPoints().then(setProofPoints);
  }, []);

  return (
    <ProofPointsContext.Provider value={{ proofPoints }}>
      {children}
    </ProofPointsContext.Provider>
  );
};

export const useProofPoints = (): ProofPointsContext => {
  const context = useContext(ProofPointsContext);
  if (context === undefined) {
    throw new Error("useProofPoints must be used within a ProofPointsProvider");
  }
  return context;
};
